import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterApprovalLogsView.
 * @extends JetView
 */
export default class FilterApprovalLogsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Datepicker label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for user ID field
                            ),
                            css: 'prm-filterByUser',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'UserName',
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Username label
                            labelPosition: 'top',
                            placeholder: _('Usuario (Correo electrónico)'), // Placeholder text
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Country selection label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Permission check for country selection
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'), // Country selection label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default country value
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Permission check for country selection
                                ),
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
            ],
        };

        // Second left section of the filter form
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'State',
                            label: _('Estado'), // State selection label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'), // Placeholder text
                            options: [
                                { id: '', value: _('Pendiente') }, // Pending state option
                                { id: '0', value: _('Aprobada') }, // Approved state option
                                { id: '1', value: _('Rechazada') }, // Rejected state option
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Field',
                            label: _('Campo'), // Field label
                            labelPosition: 'top',
                            placeholder: _('Campo'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'UserNameRequest',
                            label: _('Usuario Solicita'), // Requesting user label
                            labelPosition: 'top',
                            placeholder: _('Usuario Solicita'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left filter form
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section
                },
            ],
        };

        // Upper section 2 for additional filters
        const upper_section2 = {
            css: 'father-container',
            height: screen.width < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Upper section 2
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Enter key shortcut
                    type: 'form',
                    autowidth: true,
                    id: 'consultButton',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Button section 2 for actions in popup
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    type: 'form',
                    id: 'consultButton',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide popup after consultation
                    },
                },
            ],
        };

        // Accordion section 2 for main filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Upper section
                                    accordion_section, // Advanced filters section
                                    buttons, // Action buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section 3 for scrollable view
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Upper section and advanced filters
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Scrollable view and action buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date field
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date field
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
